import { useCallback } from 'react';
import { useStore } from './useStore';

/**
 * Indicates whether the initial UI translation has been loaded
 * @returns true if the translation has been loaded
 */
export function useTranslationLoaded() {
  const loadCount = useStore(useCallback(s => s.loadCount, []));
  return loadCount > 0;
}
